<ng-container *ngFor="let course of courses | excludeArchivedCourses; trackBy: courseId; let i = index;">
  <app-course-view-list [course]="course"></app-course-view-list>
</ng-container>
